
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../../services/transports';
import { searchStakeholders, DrugSaleToGLN, searchStakeholdersBySubscriptionType } from '../../../api/stakeholder';
import { drugsModel } from '../../../constants';
import { LabeledSelect } from '..';

export const SearchStakeholders = ({
  isPrivateManufacturerWarehouesesOnly = false,
  isDrugSale = false,
  label,
  id,
  onChange,
  withAsterisks,
  fullValue,
  byUsername,
  setValueAsObject,
  value,
  inMyCompany = false,
  ...props }) => {
  const [ t ] = useTranslation();

  const [ stakeholdersOptions, setStakeholdersOptions ] = useState(
    ...[ isDrugSale ? [ { value: '0000000000000', text: t('fields.directSale') } ] : [] ]
  );

  const [ { data }, fetchSearchStakeholders ] = useFetch(searchStakeholders,
    useCallback(response => response?.data?.container));

  const [ { data: privateSearchData }, fetchSearchPrivateStakeholders ] = useFetch(searchStakeholdersBySubscriptionType,
    useCallback(response => response?.data?.container));

  const [ { data: dragSaleData }, fetchDrugSaleData ] = useFetch(DrugSaleToGLN,
    useCallback(response => response?.data?.container));

  const onSearchStakeholder = useCallback(query => {
    if (isPrivateManufacturerWarehouesesOnly) {
      if (!isDrugSale) {
        if (query) {
          fetchSearchPrivateStakeholders({ [drugsModel.GLN_OR_QUERY]: query.trim(), inMyCompany });
        }
      } else {
        fetchDrugSaleData();
      }
    } else if (!isDrugSale) {
      if (query) {
        fetchSearchStakeholders({ [drugsModel.GLN_OR_QUERY]: query.trim(), inMyCompany });
      }
    } else {
      fetchDrugSaleData();
    }
  }, [ isPrivateManufacturerWarehouesesOnly, isDrugSale, fetchSearchPrivateStakeholders, fetchSearchStakeholders, fetchDrugSaleData, drugsModel.GLN_OR_QUERY, inMyCompany ]);


  useEffect(() => {
    let options = [];
    if (data?.length > 0) {
      if (byUsername) {
        options = data.slice().map(item =>
          ({ value: `${item.username}`, text: `${item.username} ${item.gln}` }));
      } else {
        options = fullValue
          ? data.slice().map(item => ({
            value: `${item.shId} ^break^ ${item.name} ${item.gln}`,
            text: `${item.gln} - ${item.name}` }))
          : data.slice().map(item => ({
            value: `${item.shId}`,
            text: `${item.gln} - ${item.name}`,
            item
          }));
      }
      setStakeholdersOptions(options);
    }
  }, [ data ]);


  useEffect(() => {
    let options = [];
    if (privateSearchData?.length > 0) {
      if (byUsername) {
        options = privateSearchData.slice().map(item =>
          ({ value: `${item.username}`, text: `${item.username} ${item.gln}` }));
      } else {
        options = fullValue
          ? privateSearchData.slice().map(item => ({
            value: `${item.shId} ^break^ ${item.name} ${item.gln}`,
            text: `${item.gln} - ${item.name}` }))
          : privateSearchData.slice().map(item => ({
            value: `${item.shId}`,
            text: `${item.gln} - ${item.name}`,
            item
          }));
      }
      setStakeholdersOptions(options);
    }
  }, [ privateSearchData ]);


  useEffect(() => {

    let options = [];
    if (dragSaleData?.length) {
      options = [
        { value: '0000000000000', text: t('fields.directSale') }, // as the old RSD
        ...dragSaleData.slice().map(item => ({ value: `${item.gln}`, text: `${item.name}` }))
      ];

      setStakeholdersOptions(options);
    }
  }, [ dragSaleData ]);

  return (
    <LabeledSelect
      setValueAsObject={ setValueAsObject }
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      withDebounceSearch={ true }
      onSearch={ onSearchStakeholder }
      searchDelay={ 1000 }
      options={ stakeholdersOptions }
      filterOption={ false }
      EmptyComponent={ t('ERR.noMatchedSH') }
      withAsterisks={ withAsterisks }
      placeholder={ t('fields.drug.search') }
      value={ value || undefined }
      { ...props }
    />
  );
};
